/**
 * Tiếng Việt cho MỌI component antd của ERP — truyền vào `ConfigProvider` ở `App.js` (15/09/2026).
 *
 * Trước đó chỉ màn Thống kê tự bọc `vi_VN`; mọi màn khác hiện lịch "Sep / Su Mo Tu…", phân trang "Previous Page",
 * "20 / page", "Go to", bảng rỗng "No data". Đổi ở đây là đổi chữ antd TOÀN APP: lịch, phân trang, bảng (rỗng, sắp xếp,
 * chọn tất cả), nút mặc định của `Modal.confirm`/`Popconfirm`, câu kiểm tra mặc định của `Form`, Upload, Empty…
 *
 * 🔴 Chỉ NẠP dữ liệu ngôn ngữ `vi` của dayjs, KHÔNG gọi `dayjs.locale('vi')`. rc-picker tự tra tên thứ/tháng/ngày đầu tuần
 * theo locale truyền vào (`vi_VN` → `vi`, tuần bắt đầu Thứ 2). Đặt mặc định toàn cục sẽ đổi mọi `dayjs().format('MMM/ddd')`
 * và `startOf('week')` của code nghiệp vụ — có test khoá.
 * ⚠️ Định dạng hiển thị trên ô ngày không đổi: `dateFormat: 'D/M/YYYY'` của gói `vi_VN` là trường cũ rc-picker 4 không đọc
 * (nó đọc `fieldDateFormat`, mặc định `YYYY-MM-DD`).
 * Sửa đúng một chữ của gói: ô ngày không tự đặt placeholder hiện "Chọn ngày" thay cho "Chọn thời điểm" (bản dịch
 * "Select date" của antd, lạ với ô ngày sinh / ngày cấp).
 */
import type { Locale } from 'antd/es/locale'
import viVN from 'antd/locale/vi_VN'
import 'dayjs/locale/vi'

const DATE_PLACEHOLDER = 'Chọn ngày'

export const SIMPLUS_LOCALE: Locale = {
  ...viVN,
  DatePicker: viVN.DatePicker && {
    ...viVN.DatePicker,
    lang: { ...viVN.DatePicker.lang, placeholder: DATE_PLACEHOLDER },
  },
}
